/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createSinh } from '../../factoriesAny.js';
export var sinhDependencies = {
  typedDependencies: typedDependencies,
  createSinh: createSinh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSinh.generated.js
// module id = 1653
// module chunks = 0